<template>
  <div id="box">
    <div id="hengpai" ref="con1" :class="{ anim: animate == true }">
      <Row v-for="(item, index) in percent" :key="index" :gutter="16" style="margin-bottom: 14px">
        <Col span="2"><span style="font-weight: bold; color: #1bc85e">{{
          index < 9 ? "0" + (index + 1) : index + 1 }}</span>
            </Col>
            <Col span="6">
            <span class="carNoSpan" :title="item.carNo">{{ item.carNo }}</span>
            </Col>
            <Col span="10">
            <pencer :percent="(item.number / big) * 100" background="#1cd34b"></pencer>
            </Col>
            <Col span="6">
            <span>{{ item.number }}</span><span style="opacity: 0.5; margin-left: 4px">{{ item.tag }}</span>
            </Col>
      </Row>
    </div>
  </div>
</template>
<script>
import pencer from "./percent";
export default {
  components: {
    pencer,
  },
  data() {
    return {
      searchItem: {
        "endTime": 0,
        "startTime": 0,
        "type": 1//排名类型（1：按公里数，2：按工单数）
      },
      animate: false,
      percent: [],
      big: 0,
    };
  },
  methods: {
    reach(v) {
      //this.searchItem.startTime = v.start;
      //this.searchItem.endTime = v.end;
      this.searchItem.startTime = new Date(2024, 0, 1).getTime();
      this.searchItem.endTime = Date.now();
      this.getData();
    },
    reachType(v) {
      this.searchItem.type = v;
      this.getData();
    },
    groups(v) {
      return;
      this.searchItem.groupIdList = [];
      for (let i = 0; i < v.length; i++) {
        this.searchItem.groupIdList.push(v[i].id);
      }
      this.getData();
    },
    getData() {
      var a = Date.now()
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-dpc/board/countCarRank",
        data: this.searchItem,
      }).then((res) => {
        var data = res.data.data;
        //console.log('看板里程排名',data);
        for (let i = 0; i < data.length; i++) {
          data[i].number = this.searchItem.type == 1 ? data[i].mileage : data[i].total;
          data[i].tag = this.searchItem.type == 1 ? 'km' : '单';
        }
        this.percent = data;
        console.log(24, this.percent);
        if (this.percent.length > 0) {
          this.big = this.percent[0].number;
        }
        clearInterval(this.timer1)
        if (this.percent.length >= 10) {
          this.scroll();
          this.timer1 = setInterval(this.scroll, 2000);
        }
      });
    },
    scroll() {
      let con1 = this.$refs.con1;
      con1.style.marginTop = "-30px";
      this.animate = !this.animate;
      var that = this; // 在异步函数中会出现this的偏移问题，此处一定要先保存好this的指向
      setTimeout(function () {
        that.percent.push(that.percent[0]);
        that.percent.shift();
        con1.style.marginTop = "0px";
        that.animate = !that.animate; // 这个地方如果不把animate 取反会出现消息回滚的现象，此时把ul 元素的过渡属性取消掉就可以完美实现无缝滚动的效果了
      }, 500);
    },
    mEnter() {
      clearInterval(this.timer1);
    },
    mLeave() {
      this.timer1 = setInterval(this.scroll, 2000);
    },
  },
  destroyed() {
    clearInterval(this.timer1);
  },
};
</script>
<style>
#box {
  width: 100%;
  height: calc(100% - 40px);
  line-height: 18px;
  overflow: hidden;
  padding-left: 10px;
  transition: all 0.5s;
}

.anim {
  transition: all 0.5s;
}

#hengpai .carNo123 {
  margin-bottom: 0;
  line-height: 1;
}

#hengpai .number145 {
  float: right;
  margin-top: -4px;
  color: #54c8f6;
}

#hengpai .ci {
  font-size: 14px;
  font-weight: lighter;
}

#hengpai .dac {
  transform: rotateX(360deg);
  transition: transform 0.24s;
}

.carNoSpan {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
</style>


// WEBPACK FOOTER //
// src/components/kanban/abc/licheng.vue